import { CircleCloseIcon } from 'Components/CircleCloseIcon';
import {
  Modal,
  Paper,
  Typography,
  Button,
  Stack,
  Avatar,
  IconButton,
} from '@mui/material';
import { useIsDesktop, useDictionary } from 'Hooks';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { TrashBin, WhiteTrashBin } from 'Images';
import { useDocumentUploadContext } from '../../../../../Context/DocumentUploadContext';

export const DeleteConfirmationModal = () => {
  const {
    showModal,
    pendingDeleteType,
    handleConfirmDelete,
    handleCancelDelete,
  } = useDocumentUploadContext();
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.UniversalRequest);
  return (
    <Modal
      open={showModal}
      onClose={handleCancelDelete}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: '#081E54',
            opacity: '0.8 !important',
            height: '100vh',
          },
        },
      }}
      sx={{
        zIndex: 10000,
      }}
    >
      <Paper
        sx={{
          position: 'absolute',
          top: isDesktop ? '35%' : '96px',
          left: '50%',
          transform: isDesktop ? 'translate(-50%, -50%)' : 'translate(-50%, 0)',
          width: isDesktop ? '770px' : '90%',
          backgroundColor: '#E7EDFF',
          borderRadius: '16px',
          padding: isDesktop ? '72px 26px 48px' : '72px 24px 40px',
          outline: 'none',
          border: 'none',
          boxShadow: 'none',
        }}
      >
        <IconButton
          onClick={handleCancelDelete}
          aria-label={dictionary.uploadFile.close}
          size='large'
          sx={{
            position: 'absolute',
            top: '16px',
            left: '24px',
            p: 0,
          }}
        >
          <CircleCloseIcon
            size='large'
            alt=''
            sx={{ width: '40px', height: '40px' }}
          />
        </IconButton>
        <Stack alignItems='center' justifyContent='center' gap='12px'>
          <Avatar
            alt=''
            src={TrashBin}
            sx={{ width: '160px', height: '160px', pb: '20px' }}
          />
          <Typography variant='h6'>
            {dictionary.uploadFile.removeAllDocuments(
              pendingDeleteType?.label || '',
            )}
          </Typography>
          <Typography variant='body3'>
            {dictionary.uploadFile.filesWillBeDeleted(
              pendingDeleteType?.files.length || 0,
            )}
          </Typography>
        </Stack>
        <Stack
          flexDirection='row'
          alignItems='center'
          justifyContent='center'
          gap={isDesktop ? '48px' : '22px'}
          pt='48px'
        >
          <Button
            variant='outlined'
            onClick={handleCancelDelete}
            sx={{
              p: isDesktop ? '12px 102.5px' : '8px 42.5px',
              bgcolor: '#fff',
            }}
          >
            <Typography variant='body4' color='primary.main'>
              {dictionary.uploadFile.cancel}
            </Typography>
          </Button>
          <Button
            variant='contained'
            onClick={handleConfirmDelete}
            sx={{ p: isDesktop ? '12px 77px' : '8px 29.5px', gap: '4px' }}
          >
            <Avatar
              alt=''
              src={WhiteTrashBin}
              sx={{ width: '20px', height: '20px' }}
            />
            <Typography variant='body4'>
              {dictionary.uploadFile.yesRemove}
            </Typography>
          </Button>
        </Stack>
      </Paper>
    </Modal>
  );
};
